<template>
  <div>
    <h2>{{ heading }}</h2>
    <v-slide-group v-model="slideItem" show-arrows>
      <v-slide-group-item v-for="item in items" :key="item.title">
        <v-card
          class="card"
          variant="flat"
          elevation="0"
          hover
          @click="goToPage(item.linkUrl)"
        >
          <v-img
            height="140"
            width="235"
            :src="item.imageUrl"
            cover
            class="align-end text-white flex d-flex flex-column"
          ></v-img>
          <v-card-title>{{ item.title }}</v-card-title>
          <v-card-subtitle>{{ item.subTitle }}</v-card-subtitle>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </div>
</template>
<script>
import {
  EventInfoAction,
  EventInfoCategory,
  trackTradidionalGaEvent,
} from '@/components/GoogleTagManager';

export default {
  name: 'SliderContentBlockMain',
  components: {},

  props: {
    locale: { type: String, required: true },
    heading: { type: String, required: false },
    items: { type: Array, required: false },
  },
  data() {
    return {
      slideItem: null,
    };
  },
  computed: {},
  methods: {
    goToPage(url) {
      trackTradidionalGaEvent(
        EventInfoCategory.SliderContentBlock,
        EventInfoAction.Button,
        'Page: ' + url,
      );
      window.location = url;
    },
  },
};
</script>
<style scoped>
.card {
  background-color: var(--color-surface-card);
}

.v-card-title {
  text-align: center;
}

.v-card-subtitle {
  text-align: center;
  margin-bottom: 10px;
}
</style>
